import { translateFn } from '../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';
import {
  getTargetContextFormOptions,
  getTargetTypeFormOptionsForGrid,
} from '../../../../../utils/uiSettings/applicationControl/application-control.values';
import { ApplicationControlTargetProcessType } from '@nirvana/shared/dtos/types/policies/common';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { descriptionValidators } from '../utils/validators';

export enum ColumnKeys {
  TYPE = 'type',
  MATCH = 'match',
  DESCRIPTION = 'description',
  CONTEXT = 'context',
}

export function getTableColumns(matchValidators): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.TYPE,
      header: translateFn('Authorization method'),
      columnType: IColumnType.DISPLAY,
      options: getTargetTypeFormOptionsForGrid(),
      renderer: typeCellCustomRenderer,
    },
    {
      key: ColumnKeys.MATCH,
      header: translateFn('Authorization identifier'),
      columnType: IColumnType.TEXT,
      editable: true,
      validators: matchValidators,
    },
    {
      key: ColumnKeys.DESCRIPTION,
      header: translateFn('Description'),
      columnType: IColumnType.TEXT,
      validators: descriptionValidators(),
    },
    {
      key: ColumnKeys.CONTEXT,
      header: translateFn('Source'),
      columnType: IColumnType.MULTI_SELECT,
      options: getTargetContextFormOptions(),
      validators: [RequiredValidator(translateFn('Required field'))],
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

export function typeCellCustomRenderer(content: number, column: IDataTableColumn, rowIndex: number): TemplateResult {
  const displayValue = column.options?.find(item => item.value === content);
  const formattedContent = displayValue ? displayValue.label : content;

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}

export function isContextAvailable(type: ApplicationControlTargetProcessType): boolean {
  return type === ApplicationControlTargetProcessType.PATH || !type;
}
